import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import {FormGroup} from "@angular/forms";
import { MatIconModule } from '@angular/material/icon';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'input-field',
  styleUrls: ['./input-field.component.scss'],
  templateUrl: './input-field.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFieldComponent),
      multi: true
    }
  ],
  standalone: true,
  imports: [
    IonicModule,
    CommonModule,
    ReactiveFormsModule,
  ]
})
export class InputFieldComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() formGroup: any;  
  @Input() controlName: string = '';
  @Input() color: string = 'black';
  @Input() labelPosition: any = 'floating';
  @Input() placeholder: any = '';
  @Input() type: any = 'text';
  @Input() classList: any = [];
  @Input() value: string = '';
  @Output() valueChange : EventEmitter<any> = new EventEmitter<any>();

  // Propriété pour gérer l'état désactivé
  isDisabled: boolean = false;

  /** 👁️ gestion affichage mot de passe */
  showPassword = false;

  /** Type réel de l’input */
  get computedType(): string {
    if (this.type !== 'password') return this.type;
    return this.showPassword ? 'text' : 'password';
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  
  // Cette méthode est appelée lorsque la valeur du champ change
  onValueChange(newValue: string) {
    
    this.value = newValue;
    this.valueChange.emit(newValue);
    this.onChange(newValue);
  }

  // Implémentation des méthodes de ControlValueAccessor
  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  // Fonction interne de gestion des changements
  onChange = (_: any) => {};
  onTouched = () => {};

  // Gestion de l'événement change
  @Output() changeEvent: EventEmitter<any> = new EventEmitter<any>();
  @HostListener('change', ['$event'])
  change(event: Event) {
    this.changeEvent.emit(event);
  }

  handleIonInput(event: any) {
    const newValue = event.detail?.value ?? ''; // Sécurisé
    this.onValueChange(newValue); // Appelle ta méthode
  }
  
  handleBlur() {
    this.onTouched(); // Mais → voir point 3 !
  }

  isRequired(controlName: string): boolean {
    const control = this.formGroup.get(controlName);
    if (!control || !control.validator) return false;

    const validator = control.validator({} as any);
    return validator && validator['required'];
  }
}
